import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitClassicRoute: InvariantJiraRoute = {
	name: 'software-form-submit-classic',
	path: '/jira/software/c/projects/:projectKey/form/:formId',
	exact: true,
};
